import React, { useState } from 'react';

import { Dialog, DialogContent, TextField, Typography } from '@material-ui/core';

import { useDialog } from 'hooks';
import { DialogActions, DialogTitle } from 'components';

import styles from './EditMessageDialog.module.scss';

const EditMessageDialog = ({ open, to, onClose, onMessage }) => {
  const [text, setText] = useState('');

  const dialog = useDialog(open, { data: to, onOpen: () => setText('') });

  if (dialog.isOpening && text) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle onClose={onClose}>Message Editor</DialogTitle>

      <DialogContent className={styles.content}>
        <div>
          <Typography variant="subtitle2">to:</Typography>
          <Typography variant="body1">{dialog.data}</Typography>
        </div>

        <div>
          <Typography variant="subtitle2">content:</Typography>

          <TextField
            value={text}
            onChange={e => setText(e.target.value)}
            multiline
            minRows={4}
            maxRows={4}
            autoFocus
            fullWidth
            variant="filled"
          />
        </div>
      </DialogContent>

      <DialogActions
        actions={[
          { label: 'cancel', onClick: onClose },
          {
            label: 'send',
            onClick: () => onMessage('text', { text }),
            variant: 'contained',
            disabled: !text,
          },
        ]}
      />
    </Dialog>
  );
};

export default EditMessageDialog;
